import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { EnvironmentSpecificService } from '../../environment-specific.service';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class AccessCodeService {


  apiUrl: any; // = environment.apiUrl.concat('/auth');

  constructor(private http: HttpClient, private _envSpecificSvc: EnvironmentSpecificService) {
    

    // this._http.SetUnauthorisedRequest();
    this.apiUrl = this._envSpecificSvc.envSpecific.apiURL.concat('/auth');
  }

  accesscodelogin(accessCode: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/access`, accessCode);
  }


  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
